import { render, staticRenderFns } from "./PageSlideItem.vue?vue&type=template&id=57cbf188&scoped=true&"
import script from "./PageSlideItem.vue?vue&type=script&lang=js&"
export * from "./PageSlideItem.vue?vue&type=script&lang=js&"
import style0 from "./PageSlideItem.vue?vue&type=style&index=0&id=57cbf188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cbf188",
  null
  
)

export default component.exports